// extracted by mini-css-extract-plugin
module.exports = {"Video":"YoutubeVideo_Video__9LgOZ"};